import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, TrophyIcon, AlertTriangleIcon, RadioIcon } from 'lucide-react';
export function Rules() {
  return <section id="pravidla" className="relative w-full bg-mist py-24 px-6 scroll-mt-20 overflow-hidden" data-id="element-224">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mukNHx9uaN2UkH4Wg5ELUP/DSC01389.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.7
    }} data-id="element-225" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-227">
          <h2 className="text-[48px] font-[200] mb-4 text-[#FFFFFF]" data-id="element-228">
            Soutěžní pravidla a procedury
          </h2>
          <p className="max-w-2xl text-lg text-[#FFFFFF]" data-id="element-229">
            Spinnaker a gennaker jsou povoleny, pokud rozhodčí nevyhlásí jinak.
            Vše se řídí fair-play a námořním právem.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-230">
          {/* Bodování */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-231">
            <div className="flex items-center gap-4 mb-6" data-id="element-232">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-233">
                <ScaleIcon className="w-6 h-6" data-id="element-234" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-235">
                Bodování a hodnocení
              </h3>
            </div>
            <ul className="space-y-3 text-white/90" data-id="element-236">
              <li data-id="element-237">
                • Boduje se nízkobodovým systémem (1. místo = 1 bod, 2. místo =
                2 body...).
              </li>
              <li data-id="element-238">• Za každé odjeté 4 rozjížďky se jedna nejhorší škrtá.</li>
              <li data-id="element-239">• Rozhodčí může vyhlásit rozjížďku s vícebodovým ziskem.</li>
              <li data-id="element-240">
                • Limity dojezdů mohou být upraveny během plavby přes VHF a
                WhatsApp.
              </li>
            </ul>
          </motion.div>

          {/* Modrá stuha */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border-l-4 border-blue-medium border-t border-r border-b border-white/10" data-id="element-241">
            <div className="flex items-center gap-4 mb-6" data-id="element-242">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-243">
                <TrophyIcon className="w-6 h-6" data-id="element-244" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-245">Modrá stuha</h3>
            </div>
            <p className="text-white/90 mb-4" data-id="element-246">
              Vyhlašuje se i vložená soutěž pro posádku s nejkratším celkovým
              časem ze všech rozjížděk (včetně škrtaných v hlavní soutěži).
            </p>
            <p className="text-sm text-white/70 italic" data-id="element-247">
              Podmínkou účasti je odjetí všech vyhlášených rozjížděk. Posádka si
              může "vypůjčit" zkušeného jachtaře z rozhodcovské lodě pro
              zdokonalení – tato rozjížďka se však lodi škrtá.
            </p>
          </motion.div>

          {/* Startovací procedura */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-248">
            <div className="flex items-center gap-4 mb-6" data-id="element-249">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-250">
                <RadioIcon className="w-6 h-6" data-id="element-251" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-252">
                Startovací procedura
              </h3>
            </div>
            <p className="text-white/90 mb-4" data-id="element-253">
              Procedura bude 5, 4, 1 (min.), start. Zvukové znamení probíhá
              prostřednictvím vysílačky:
            </p>
            <ul className="space-y-2 text-sm text-white/80 bg-black/20 p-4 rounded-lg font-mono" data-id="element-254">
              <li data-id="element-255">10 min - "Alpha ... 5,4,3,2,1, teď"</li>
              <li data-id="element-256">5 min - "Charlie ... 5,4,3,2,1, teď" (zahájení)</li>
              <li data-id="element-257">4 min - "Kilo ... 5,4,3,2,1, teď" (vypnutí motoru)</li>
              <li data-id="element-258">1 min - "Lima ... 5,4,3,2,1, teď" (synchronizace)</li>
              <li data-id="element-259">START - "November ... 5,4,3,2,1, teď"</li>
            </ul>
          </motion.div>

          {/* Bezpečnost a tresty */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-260">
            <div className="flex items-center gap-4 mb-6" data-id="element-261">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-262">
                <AlertTriangleIcon className="w-6 h-6" data-id="element-263" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-264">
                Bezpečnost a tresty
              </h3>
            </div>
            <ul className="space-y-3 text-white/90" data-id="element-265">
              <li data-id="element-266">
                • <strong data-id="element-267">Motor:</strong> Lze nastartovat z bezpečnostních
                důvodů bez penalizace (bez zařazené rychlosti, nutno oznámit
                přes VHF).
              </li>
              <li data-id="element-268">
                • <strong data-id="element-269">Vyhýbání:</strong> Striktně dle COLREGu. Plachetnice
                dává přednost běžným motorovým lodím, rybářům a veřejné dopravě.
              </li>
              <li data-id="element-270">
                • <strong data-id="element-271">Penalizace:</strong> Při přejetí startovní linie nebo
                nedání přednosti je trest 360° otočka do cíle rozjížďky.
                Poškozená loď hlásí "PROTEST" vysílačkou i do WhatsApp skupiny.
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}